module.exports = __webpack_public_path__ + "img/3E3E36_72726D_63645D_0E0F0C-256px.3a09b21c.png";